import { create } from 'zustand';

// Estado editável de um orçamento (o que se salva no banco em `dados`).
export interface OrcamentoDraftData {
  cliente: { nome: string; cidade: string; uf: string; cep: string; animais: string };
  params: {
    cambio: number;
    iiPct: number;
    icmsPct: number;
    freteIntlUsd: number;
    margemPct: number;
    freteNacional: number;
    descontoBrincoPct: number;
    descontoBrincoReais: number;
  };
  software: { plano: string; mensal: number; meses: number };
  planoId: number | 'custom';
  interno: { impostoVendaPct: number; custoBrincoReais: number };
  kit: { produtoId: number; quantidade: number }[];
  // De onde sai o frete. Opcional: orçamentos antigos não têm (saíam de Campo Grande).
  origem?: { cep: string; local: string };
}

interface DraftState {
  // `nonce` garante que reabrir o MESMO orçamento redispare a hidratação.
  pending: { nonce: number; data: OrcamentoDraftData; id?: number } | null;
  loadDraft: (data: OrcamentoDraftData, id?: number) => void;
  clear: () => void;
}

export const useOrcamentoDraft = create<DraftState>((set) => ({
  pending: null,
  loadDraft: (data, id) =>
    set((s) => ({ pending: { nonce: (s.pending?.nonce || 0) + 1, data, id } })),
  clear: () => set({ pending: null }),
}));
